import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { Subscription } from "rxjs";
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';

@Component({
  selector: 'app-popup-outstanding-balance',
  templateUrl: './popup-outstanding-balance.component.html',
  styleUrls: ['./popup-outstanding-balance.component.sass']
})
export class PopupOutstandingBalanceComponent implements OnInit {
  public expiredBalance;
  public currentBalance;
  public origin;
  public selectBan;
  public token:string=sessionStorage.getItem("token");
  paymentReceived: Subscription;
  public cr;

  constructor(private loadingScreenService: LoadingScreenService, public dialog: MatDialog, public matDialogRef: MatDialogRef<PopupOutstandingBalanceComponent>, private services: Service, private global: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {
    if (data.expiredBalance != undefined) {
      this.expiredBalance = data.expiredBalance;
    }
    if (data.currentBalance != undefined) {
      this.currentBalance = data.currentBalance;
    }
    if (data.cr != undefined) {
      this.cr = data.cr;
    }
    if (data.origin != undefined) {
      this.origin = data.origin;
    }
  }

  ngOnInit() {
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    this.paymentReceived = this.global.paymentReceived.subscribe((value:boolean) => {
      if (value == true) {
      this.router.navigate(['internalreferred']);
      }
    });
  }
  payBalance(){
    let typeMessage='payment';
    this.global.newPaymentNoLimit(1,typeMessage,this.selectBan,atob(sessionStorage.getItem("defaultSubscriber")),this.currentBalance,atob(sessionStorage.getItem("email")),sessionStorage.getItem("name"),"",this.token);
    this.close();
  }
  close() {
    this.matDialogRef.close('cancel');
  }
}
